// src/components/Hero.js
import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3
      }
    }
  };

  const wordVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section style={styles.hero}>
      <div style={styles.container}>
        <motion.div
          initial="hidden"
          animate="visible"
          variants={textVariants}
          style={styles.titleWrapper}
        >
          {["¿Quieres", "el mejor precio,", "sin perder", "horas buscando?"].map((word, i) => (
            <motion.span key={i} variants={wordVariants} style={styles.word}>
              {word}{' '}
            </motion.span>
          ))}
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 0.8 }}
          style={styles.subtitle}
        >
          En Quadramelo, nuestro equipo de buscadores expertos encuentra por ti 
          el producto que deseas, al precio ideal, con total transparencia y sin estrés.
        </motion.p>

        <motion.button
          whileHover={{ scale: 1.05, boxShadow: '0 6px 20px rgba(67, 97, 238, 0.4)' }}
          whileTap={{ scale: 0.95 }}
          style={styles.ctaButton}
        >
          Encuentra tu producto hoy
        </motion.button>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    backgroundColor: '#f8f9fa',
    padding: '6rem 1rem 4rem',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden'
  },
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    position: 'relative',
    zIndex: 1
  },
  titleWrapper: {
    fontSize: '2.8rem',
    fontWeight: '800',
    color: '#212529',
    marginBottom: '1.2rem',
    lineHeight: 1.2,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  word: {
    display: 'inline-block',
    marginRight: '0.5rem'
  },
  subtitle: {
    fontSize: '1.2rem',
    color: '#6c757d',
    marginBottom: '2.5rem',
    lineHeight: 1.7,
    maxWidth: '600px',
    margin: '0 auto'
  },
  ctaButton: {
    backgroundColor: '#4361ee',
    color: '#fff',
    border: 'none',
    padding: '0.9rem 2.2rem',
    fontSize: '1.15rem',
    fontWeight: '600',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.3s',
    boxShadow: '0 4px 12px rgba(67, 97, 238, 0.3)',
    position: 'relative',
    zIndex: 2
  }
};

export default Hero;